<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="12" :sm="12">
            <a-form-item :label="$t(I18N_KEY.ORDER + 'loanTime')">
              <a-range-picker v-model="queryParam.lendingTime" format="YYYY-MM-DD" style="width: 100%;" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="8" :sm="12">
            <a-form-item :label="$t(I18N_KEY.ORDER + 'ProductType')">
              <a-select v-model="queryParam.appssidList">
                <a-select-option v-for="item in appList" :key="item.appssid">
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="12">
            <a-form-item :label="$t(I18N_KEY.ORDER + 'channelListZH')">
              <a-select default-value="" style="width: 100%" v-model="queryParam.channelList">
                <a-select-option v-for="item in channelList" :value="item">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="24" :sm="24">
            <a-form-item :label="$t(I18N_KEY.ORDER + 'adgroupNameListZH')">
              <a-select style="width: 100%" v-model="queryParam.adgroupNameList">
                <a-select-option v-for="(item, index) in adgroupNameList" :key="index" :value="item">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{
                $t('reset')
              }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

          <a-table
              ref='table'
              size='middle'
              :columns='columns'
              :dataSource='dataSource'
              :pagination='false'
              :loading='loading'
              bordered
          >
              <a-table
                slot='expandedRowRender'
                slot-scope='text'
                ref='table'
                size='middle'
                :columns='childColumns'
                :dataSource='text.channelDetails'
                :pagination='false'
                :loading='loading'
                bordered
                v-if="text.beginDate !== 'Total'"
              >
                  <a-table
                    slot='expandedRowRender'
                    slot-scope='text'
                    ref='table'
                    size='middle'
                    :columns='adgroupDetails'
                    :dataSource='text.adgroupDetails'
                    :pagination='false'
                    :loading='loading'
                    bordered
                    v-if="text.beginDate !== 'Total'"
                  >
                  </a-table>

              </a-table>
            </a-table>


      <div style="margin-top: 15px; text-align: right;">
        <v-pagination
          v-if="total"
          :page-num="queryParam.pageNum"
          :page-size="queryParam.pageSize"
          :total="total"
          @change="handleTableChange"
        />
      </div>
    </div>
    <v-modal v-model="visible" :title="$t('order.collectionDetail')">
      <div style="padding: 20px;">
        <collection-detail
          v-if="visible"
          :orderId="orderId"
          :custInfoId="custInfoId"
          :taskId="taskId"
          :auditDrawer="false"
          @close="visible = false"
        />
      </div>
    </v-modal>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import {
  convertDataAdgroupNameDelivery,
  getApplist,
  getChannelContentSelect,
  getListAdvertisingContentSelect
} from '@/webpublicapi/order'
import { getAllDeadlineConfig } from '@/webpublicapi/deadlineConfig'
import Dict from '../modules/Dict.vue'
import DictSelect from '../modules/DictSelect.vue'
import exportFile from '@/webpublicapi/exportFile'
import moment from 'moment'
import vModal from '../modules/Modal.vue'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  COLLECTION: 'collection.'
}

export default {
  name: 'ConvertDataAdgroupNameDelivery',
  components: {
    Dict,
    DictSelect,
    vModal
  },
  data() {
    return {
      I18N_KEY,
      toggleSearchStatus: false,
      visible: false,
      orderId: undefined,
      custInfoId: undefined,
      taskId: undefined,
      // 分页参数
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      appList: [],
      adgroupNameList: [],
      deadlineConfigList: [],
      channelList: [],
      // 查询条件
      queryParam: {
        deadlineConfigValue: '',
        orderNo: '',
        appssidList: '',
        mobileNo: '',
        orderType: '',
        lendingTime: [moment().add('days', -2), moment().add('days', 0)],
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('order.beginDateZH'),
          align: 'left',
          dataIndex: 'beginDate'
        },
        {
          title: this.$t('order.company'),
          align: 'left',
          dataIndex: 'company'
        },
        {
          title: this.$t('order.payTotalZH'),
          align: 'left',
          dataIndex: 'payTotal'
        },
        {
          title: this.$t('order.unsettleCountZH'),
          align: 'left',
          dataIndex: 'unsettleCount'
        },
        {
          title: this.$t('order.earlySettleCountZH'),
          align: 'left',
          dataIndex: 'earlySettleCount'
        },
        {
          title: this.$t('order.settleCountZH'),
          align: 'left',
          dataIndex: 'settleCount'
        },
        {
          title: this.$t('order.overdueSettleCountZH'),
          align: 'left',
          dataIndex: 'overdueSettleCount'
        },
        {
          title: this.$t('order.overdueRateZH'),
          align: 'left',
          dataIndex: 'overdueRate'
        }
      ]
    },
    childColumns() {
      return [
        {
          title: '日期',
          align: 'left',
          dataIndex: 'beginDate'
        },
        {
          title: '渠道',
          align: 'left',
          dataIndex: 'channel'
        },
        {
          title: this.$t('order.payTotalZH'),
          align: 'left',
          dataIndex: 'payTotal'
        },
        {
          title: this.$t('order.unsettleCountZH'),
          align: 'left',
          dataIndex: 'unsettleCount'
        },
        {
          title: this.$t('order.earlySettleCountZH'),
          align: 'left',
          dataIndex: 'earlySettleCount'
        },
        {
          title: this.$t('order.settleCountZH'),
          align: 'left',
          dataIndex: 'settleCount'
        },
        {
          title: this.$t('order.overdueSettleCountZH'),
          align: 'left',
          dataIndex: 'overdueSettleCount'
        },
        {
          title: this.$t('order.overdueRateZH'),
          align: 'left',
          dataIndex: 'overdueRate'
        }
      ]
    },
    adgroupDetails() {
      return [
        {
          title: '日期',
          align: 'left',
          dataIndex: 'beginDate'
        },
        {
          title: '广告组',
          align: 'left',
          dataIndex: 'adGroup'
        },
        {
          title: this.$t('order.payTotalZH'),
          align: 'left',
          dataIndex: 'payTotal'
        },
        {
          title: this.$t('order.unsettleCountZH'),
          align: 'left',
          dataIndex: 'unsettleCount'
        },
        {
          title: this.$t('order.earlySettleCountZH'),
          align: 'left',
          dataIndex: 'earlySettleCount'
        },
        {
          title: this.$t('order.settleCountZH'),
          align: 'left',
          dataIndex: 'settleCount'
        },
        {
          title: this.$t('order.overdueSettleCountZH'),
          align: 'left',
          dataIndex: 'overdueSettleCount'
        },
        {
          title: this.$t('order.overdueRateZH'),
          align: 'left',
          dataIndex: 'overdueRate'
        }
      ]
    }
  },
  created() {
    getApplist().then(res => {
      this.appList = res.data || []
    })
    getListAdvertisingContentSelect().then(res => {
      this.adgroupNameList = res.data.adgroupNameList.map(item => item.adgroupName) || []
    })
    getChannelContentSelect().then(res => {
      this.channelList = res.data || []
    })

    this.getDict()
    this.loadData(1)
    getAllDeadlineConfig().then(res => {
      this.deadlineConfigList = res.data || []
    })
  },
  methods: {
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.queryParam.pageNum = 1
        this.queryParam.pageSize = 10
      }
      this.loading = true
      let params = this.getQueryParams() // 查询条件
      console.log(params)
      convertDataAdgroupNameDelivery(Object.assign({}, params))
        .then(res => {
          if (res.code === 1000) {
            this.total = res.data.total
            console.log(res.data.rows)
            this.dataSource = res.data.rows || []
          } else {
            this.total = 0
            this.dataSource = []
            this.$message.error(res.msg)
          }
          this.loading = false
        })
        .catch(e => {
          this.loading = false
          this.$message.error(e.message)
        })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    getQueryParams() {
      const { lendingTime } = this.queryParam
      const data = {
        ...this.queryParam,
        startDate: lendingTime && lendingTime.length ? this.transformTime(lendingTime[0]) : undefined,
        endDate: lendingTime && lendingTime.length ? this.transformTime(lendingTime[1]) : undefined
      }
      delete data.applyDate
      var param = Object.assign({}, data)

      return filterObj(param)
    },
    handleTableChange(pageNum, pageSize) {
      this.queryParam.pageNum = pageNum
      this.queryParam.pageSize = pageSize
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.lendingTime = [moment().add('days', -1), moment().add('days', 0)]
      that.queryParam.adgroupNameList = ''
      that.queryParam.appssidList = ''
      that.queryParam.channelList = ''
      that.loadData(this.queryParam.pageNum)
    },
    changeModal(visible) {
      this.visible = visible
    },
    rowClassName(record, index) {
      var date = new Date(record.curDate)
      var day = date.getTime() / 24 / 60 / 60 / 1000 + 3
      console.log(record.curDate, date, (day % 7) + 1)

      if ((day % 7) + 1 == 7) {
        return 'table_weekendColor'
      }
      return ''
    }
  }
}
</script>
<style lang="less" scoped>
@import '~@/assets/less/common.less';
</style>
